import { Stack, Typography } from '@mui/material';
import { StyledCardContainer, StyledContainer } from './Filter.components';
import { ControlledInputs, Grid, PrimaryButton } from '@/components';
import { useForm } from 'react-hook-form';
import { Card } from './Card';
import { useDashboardFormContext } from '../hooks';

export const SecondSection = () => {
  const form = useDashboardFormContext();
  return (
    <StyledContainer>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        pb={1}
      >
        <Typography fontSize={24}>Transaction Data Visualization</Typography>
        <Stack direction="row" gap={2}>
          <ControlledInputs.DatePicker
            ControllerProps={{
              control: form.control,
              name: 'date',
            }}
          />
          <ControlledInputs.Select
            ControllerProps={{
              control: form.control,
              name: 'type',
            }}
            placeholder="Select..."
            options={[
              { id: 1, name: 'Reward' },
              { id: 2, name: 'Grant' },
              { id: 3, name: 'Adjustment' },
            ]}
            optionKeys={{
              value: 'id',
              label: 'name',
            }}
          />
        </Stack>
      </Stack>
      <Card />
    </StyledContainer>
  );
};
